import { postData } from './session';

export async function getTabletWorkSummary(meta = {}, payload = {}) {
    return await postData('com.rnis.kurs.action.portal.date.tasks.item_chart.list', meta, { payload: {} })
}


// WEBPACK FOOTER //
// ./src/helpers/api/reports.js